import { onMounted, onUnmounted, ref, type Ref } from 'vue'

import { emitter } from '@/shared/services/emitter'
import { EmitterEvents } from '@/shared/types/emitter-events'

export type OpenChatAsideOptions = {
  openGroupSettings?: boolean
}

const pendingOpenGroupSettings = ref(false)

export const openChatAside = (options?: OpenChatAsideOptions) => {
  pendingOpenGroupSettings.value = Boolean(options?.openGroupSettings)
  emitter.emit(EmitterEvents.OPEN_CHAT_ASIDE)
}

export const consumeOpenGroupSettingsRequest = (): boolean => {
  const value = pendingOpenGroupSettings.value
  pendingOpenGroupSettings.value = false
  return value
}

export const useOpenChatAsideListener = (isAsideActive: Ref<boolean>) => {
  const onOpenChatAside = () => {
    isAsideActive.value = true
  }

  onMounted(() => {
    emitter.on(EmitterEvents.OPEN_CHAT_ASIDE, onOpenChatAside)
  })

  onUnmounted(() => {
    emitter.off(EmitterEvents.OPEN_CHAT_ASIDE, onOpenChatAside)
  })
}

